import { route, fallback } from './router';
import { html } from './dom';
import type { Layout, RouteHandler } from './types';
import * as remotion from '../pages/remotion';
import * as home from '../pages/home';
import * as overview from '../pages/overview';
import * as projects from '../pages/projects';
import * as workspaces from '../pages/workspaces';
import * as project from '../pages/project';
import * as flow from '../pages/flow';
import * as flowDetails from '../pages/flow-details';
import * as flows from '../pages/flows';
import * as useAsApp from '../pages/use-as-app';
import * as library from '../pages/library';
import * as asset from '../pages/asset';
import * as brands from '../pages/brands';
import * as runs from '../pages/runs';
import * as settings from '../pages/settings';
import * as knowledge from '../pages/knowledge';
import * as gallery from '../pages/gallery';
import * as marketplace from '../pages/marketplace';
import * as placeholders from '../pages/placeholders';
import * as admin from '../pages/admin/index';

const R = (pattern: string, page: RouteHandler['page'], layout: Layout = 'app', nav?: string) => route(pattern, { page, layout, nav });

R('/remotion-templates', remotion.render, 'app', 'remotion-templates');
R('/', home.render, 'app', 'home');
R('/overview', overview.render, 'app', 'overview');
R('/assets', library.render, 'app', 'assets');
R('/assets/templates/new', remotion.render, 'app', 'assets');
R('/assets/templates/:templateId/edit', remotion.render, 'app', 'assets');
R('/assets/:assetId', asset.render, 'app', 'assets');
R('/flows', flows.render, 'app', 'flows');
R('/apps', useAsApp.render, 'app', 'apps');
R('/use-as-app', useAsApp.render, 'app', 'use-as-app');
R('/app/:appId', useAsApp.renderApp, 'app', 'use-as-app');
R('/projects', projects.render, 'app', 'projects');
R('/projects/:projectId', project.render, 'app', 'projects');
R('/projects/:projectId/flows/:flowId/details', flowDetails.render, 'app', 'flows');
R('/projects/:projectId/flows/:flowId', flow.render, 'flow', 'projects');
R('/flows/:flowId', flow.redirect, 'flow', 'projects');
R('/workspaces', workspaces.renderList, 'app', 'workspaces');
R('/workspaces/:workspaceId', workspaces.renderDetail, 'app', 'workspaces');
R('/executions', runs.renderList, 'app', 'executions');
R('/executions/:runId', runs.renderDetail, 'app', 'executions');
R('/library', library.render, 'app', 'assets');
R('/library/:assetId', asset.render, 'app', 'assets');
R('/brands', brands.renderList, 'app', 'brands');
R('/brands/:brandId', brands.renderDetail, 'app', 'brands');
R('/runs', runs.renderList, 'app', 'runs');
R('/runs/:runId', runs.renderDetail, 'app', 'runs');
R('/settings', settings.render, 'app', 'settings');
R('/knowledge', knowledge.render, 'app', 'knowledge');
R('/gallery', gallery.renderList, 'community', 'gallery');
R('/gallery/:itemId', gallery.renderDetail, 'community', 'gallery');
R('/marketplace', marketplace.renderList, 'community', 'marketplace');
R('/marketplace/:listingId', marketplace.renderDetail, 'community', 'marketplace');
admin.routes.forEach(([pattern, page, nav]) => R(pattern, page, 'admin', nav));
fallback({ page: () => ({ title: 'Not found', body: html`<div class="page"><div class="empty">This page doesn’t exist. <a class="link" href="#/">Go home</a></div></div>` }), layout: 'app' });
